export default __webpack_public_path__ + "7368c35532cd4deb0272cbe0d69d130e.svg";